import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Layout, Badge, Alert } from "antd";
import {
  AlertOutlined,
  BellOutlined,
  UserOutlined,
  WarningFilled,
  WarningOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import { message } from "antd";
import { Button, Modal, Popover, Empty } from "antd";
import { useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import {
  loadUpdates,
  callNotifications,
  getAllAlerts
} from "../../redux/DashboardRedux/DashboardActions";
// import "../Support/Header.css";
import "../../GlobalCss/SPF/Header.css";
import { Redirect } from "react-router-dom";
import { Input } from "antd";
import { decrypt } from "../../Utils/Utils";
const { TextArea } = Input;
const { Header, Content } = Layout;

const Navbar = () => {
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const name=Cookies.get("first_name");
  const firstName = decrypt(name) ;
  const lastName = Cookies.get("last_name");
const role= Cookies.get("Role");
  const userRole = decrypt(role);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [incidentError, setIncidentError] = useState("")
  // const [notificationCount, setNotificationCount] = useState(0)
  // const [updateStatusData, setUpdateStatusData] = useState([])
  const [DeclineLoading, setDeclineLoading] = useState(null);
  const [approvalLoading, setApprovalLoading] = useState(null);
  const currentdate = new Date();
  const [showFullContent, setShowFullContent] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const [Calresult, setCalResult] = useState("");
  const [CalcurrentInput, setCalCurrentInput] = useState("");
  const [calresErr, setCalResulterr] = useState('')

  useEffect(() => {
    dispatch(callNotifications());
    dispatch(getAllAlerts());
  }, []);
  const updateStatusData = useSelector(
    (state) => state.dashboardreducer.totalNotifications
  );
  const alertsData = useSelector(
    (state) => state.dashboardreducer.totalAlerts
  )
  const notificationCount = updateStatusData.length;
  const OverduetasksCount = alertsData.length;
  const total = notificationCount + OverduetasksCount;

  const handleClick = () => {
    const trimmedContent = value.trim();
    if (trimmedContent.length === 0) {
      setIncidentError('*Please enter text');
      setValue([])
      return;
    }
    const userData = {
      fromAddress: userLogin,
      tos: ["servicedesk@spectraforce.com"],
      fromName: firstName,
      subject: "InTime User Incident",
      body: value,
    };

    const url = `${process.env.REACT_APP_BASE_URL}HelpSupport/send-email`;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    setLoading(true);
    axios.post(url, JSON.stringify(userData), config).then((response) => {
      message.success(`Submitted your incident successfully.`);
      setLoading(false);
      setValue([]);
    });
  };

  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  const onchangeIncident = (e) => {
    setValue(e)
    setIncidentError('')
  }
  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setValue([]);
    setOpen(false);
    setIncidentError('')
  };
  const discardNotification = async (id, description, getStatus, i) => {
    const tempId = id;
    const tempDesc = description;
    const tempStatus = getStatus;
    const index = i;
    // console.log(tempStatus)
    if (tempStatus === "Approved") {
      setApprovalLoading(index);
    } else {
      setDeclineLoading(index);
    }
    try {
      let url = `${process.env.REACT_APP_BASE_URL}DashBoard/PayrollUpdateActionStatus`;
      const adding = {
        "id": tempId,
        "title": "payroll update",
        "description": tempDesc,
        "submitted_By": userLogin,
        "status": tempStatus,
      };
      const response = await axios.put(url, adding, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        }
      }
      )
      const res = await dispatch(callNotifications());
      setDeclineLoading(null)
      setApprovalLoading(null)
      if (tempStatus === 'Approved') {
        const res = await dispatch(loadUpdates());
        success()
      }
    } catch (error) {
      setDeclineLoading(null);
      setApprovalLoading(null);
    }
  };
  const success = () => {
    messageApi.open({
      type: "success",
      content: "Update added",
    });
  };
  const toggleShowmore = (e, index) => {
    e.stopPropagation();
    if (showFullContent.includes(index)) {
      setShowFullContent(showFullContent.filter((id) => id !== index));
    } else {
      setShowFullContent([...showFullContent, index]);
    }
  };

  const renderContent = (item, index) => {

    return (
      <div
        key={index}
        dangerouslySetInnerHTML={{
          __html: item,
        }}
      />
    );

  };

  //Calculator Functionality
  const handleCalInput = (value) => {
    setCalResulterr('')
    setCalCurrentInput(CalcurrentInput + value);
  };
  const handleChange = (e) => {
    setCalResulterr('')
    setCalCurrentInput(e.target.value);
  };
  const calculateResult = () => {
    try {
      setCalResult(eval(CalcurrentInput).toString());
    } catch (error) {
      setCalResult('')
      setCalResulterr('Invalid input');
    }
  };
  const clearInput = () => {
    setCalCurrentInput("");
    setCalResult("");
    setCalResulterr('')
  };
  const handleBackspace = () => {
    setCalCurrentInput(CalcurrentInput.slice(0, -1));
  };


  const content = (
    <div>
      {total !== 0 ? (
        <div className="note-inside">
          {updateStatusData.length !== 0 ? (
            updateStatusData.map((item, index) => {
              return (
                <div className="notification-showing">
                  <div className="email-showing" key={index}>
                    {item.submitted_By}
                  </div>
                  <div className="update-showing" key={index}>
                    {item.description.length <= 40 ||
                      showFullContent.includes(index) ? (
                      <p>{renderContent(item.description, index)}</p>
                    ) : (
                      <p key={index}>{renderContent(item.description, index)}</p>
                    )}

                    {/* {ExtractTextFromHtml(item.description).length > 40 ? (
                  <div className="moreless-class">
                    {" "}
                    <button
                      onClick={(e) => toggleShowmore(e, index)}
                      className="moreless-button"
                    >
                      {showFullContent.includes(index) ? (
                        <span>
                          <span style={{ marginRight: 5 }}>Show less</span>
                          <UpOutlined style={{ color: "#002766" }} />
                        </span>
                      ) : (
                        <span>
                          <span style={{ marginRight: 5 }}>Show more</span>
                          <DownOutlined style={{ color: "#002766" }} />
                        </span>
                      )}
                    </button>{" "}
                  </div>
                ) : null} */}
                  </div>
                  <div className="publish-or-discard-class">
                    <Button
                      className="approve-button"
                      loading={approvalLoading === index}
                      onClick={() =>
                        discardNotification(
                          item.id,
                          item.description,
                          "Approved",
                          index
                        )
                      }
                    >
                      Approve
                    </Button>
                    <Button
                      className="reject-button"
                      style={{ marginLeft: 6 }}
                      loading={DeclineLoading === index}
                      onClick={() =>
                        discardNotification(
                          item.id,
                          item.description,
                          "Decline",
                          index
                        )
                      }
                    >
                      Reject
                    </Button>
                  </div>
                  {contextHolder}
                </div>
              );
            })
          ) : (
            <div>
            </div>
          )}
          <div>
            {
              alertsData ? alertsData.map((item, index) => {
                return (
                  <div className="usertaskAlert-showing">
                    <WarningOutlined style={{ marginRight: 8 }} />
                    <p>{item.taskName}</p>
                  </div>
                )
              }) : <div>
              </div>
            }
          </div>
        </div>
      ) : (
        <div className="nodata-notification">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={"No notifications"}
          />
        </div>
      )}
    </div>
  );
  const userContent = (

    <div>
      {total !== 0 ? (
        <div className="note-inside">
          {updateStatusData.length !== 0 ? (
            updateStatusData.map((item, index) => {
              return (
                <div className="notification-showing" key={index}>
                  <div className="update-showing">
                    {item.description.length <= 40 || showFullContent.includes(index) ? (
                      <p>{renderContent(item.description, index)}</p>
                    ) : (
                      <p>
                        {renderContent(item.description, index)}
                      </p>
                    )}
                  </div>
                  <div className="publish-or-discard-class">
                    {item.status === "Decline" ? (
                      <div className="user-status">Declined</div>
                    ) : item.status === "Draft" ? (
                      <div className="user-status">Pending</div>
                    ) : (
                      <div className="user-status">{item.status}</div>
                    )}
                  </div>
                  {contextHolder}
                </div>
              );
            })
          ) : (
            <div>
            </div>
          )}
          <div>
            {alertsData ? (
              alertsData.map((item, index) => {
                return (
                  <div className="usertaskAlert-showing" key={index}>
                    <WarningOutlined style={{ marginRight: 8, fontSize: 18 }} />
                    <p>{item.taskName}</p>
                  </div>
                );
              })
            ) : (
              <div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="nodata-notification">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={"No notifications"}
          />
        </div>
      )}
    </div>
  );
  const Calculatorcontent = (
    <div >
      <div style={{ marginBottom: "10px", marginLeft: "10px" }}>
        <Input placeholder="Enter calculation" value={CalcurrentInput} style={{ width: "70%" }} onChange={handleChange} />
        {Calresult ? (<div style={{ marginLeft: "10px", width: "50%", fontWeight: "bold", fontSize: 33 }}>
          {Calresult}
        </div>) : <div style={{ color: "red" }}>{calresErr}</div>}
      </div>
      <div style={{ marginLeft: "8px" }}>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("(")}>(</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput(")")}>)</Button>
        {/* <Button style={{ margin: "2%" }} onClick={handleSquareRoot}>√</Button> */}
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput(".")}>.</Button>
        <Button style={{ margin: "2%" }} onClick={handleBackspace}>⌫</Button>
        <br />
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("1")}>1</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("2")}>2</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("3")}>3</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("+")}>+</Button>
        <br />
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("4")}>4</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("5")}>5</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("6")}>6</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("-")}>-</Button>
        <br />
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("7")}>7</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("8")}>8</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("9")}>9</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("*")}>*</Button>
        <br />
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("0")}>0</Button>
        <Button style={{ margin: "2%" }} onClick={clearInput}>C</Button>
        <Button style={{ margin: "2%" }} onClick={calculateResult}>=</Button>
        <Button style={{ margin: "2%" }} onClick={() => handleCalInput("/")}>/</Button>
      </div >
    </div>
  );

  return (
    <div>
      <div className="navbar-elements">
        {userRole === "Super User" ? (
          <div style={{ cursor: "pointer" }}>
            <Popover
              placement="bottom"
              content={content}
              trigger="click"
              className="notification-popover"
            >
              <Badge size="small" count={total} color="rgba(59, 82, 223, 1)">
                <Avatar style={{ backgroundColor: "#FFFF" }}>
                  <BellOutlined style={{ color: "rgba(59, 82, 223, 1)", fontSize: "20px", fontWeight: "500" }}/>
                </Avatar>
              </Badge>
            </Popover>
          </div>
        ) : (
          <div style={{ cursor: "pointer" }}>
            <Popover
              placement="bottom"
              content={userContent}
              trigger="click"
              className="notification-popover"
            >
              <Badge size="small" count={total} color="#FFA39E">
                <Avatar style={{ backgroundColor: "#FFFF" }}>
                  <BellOutlined style={{ color: "rgba(59, 82, 223, 1)", fontSize: "20px", fontWeight: "500" }}/>
                </Avatar>
              </Badge>
            </Popover>
          </div>
        )}
        <Avatar style={{ backgroundColor: "#FFFF" }} icon={<UserOutlined style={{ color: "rgba(59, 82, 223, 1)", fontSize: "20px", fontWeight: "500" }} />} />
        <p className="header-user"> {firstName} </p>
        <Tooltip title="Raise support Incident">
          <img
            src="/Images/Support.svg"
            alt="Mail"
            className="icon-raise"
            onClick={showModal}
          />
        </Tooltip>
        <Popover content={Calculatorcontent} trigger="click">
          <Tooltip title="Calculator">
            <img
              src="/Images/Group 1081.svg"
              alt="Calculator"
              className="icon-raise"
            />
          </Tooltip>
        </Popover>
      </div>
      <Modal
        open={open}
        onOk={handleClick}
        onCancel={handleCancel}
        footer={[
          <Button
            style={{ backgroundColor: "rgba(59, 82, 223, 1)", fontFamily: "Poppins" }}
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => handleClick()}
          >
            Submit Incident
          </Button>,
        ]}
      >
        <label className="subject-label" for="Subject">
          Subject:
        </label>
        <Input
          className="prevent-select"
          disabled
          id="Name"
          name="Subject"
          style={{ color: "rgba(59, 82, 223, 1)" }}
          placeholder="InTime User Incident"
        ></Input>
        <TextArea
          id="textbox"
          value={value}
          onChange={(e) => onchangeIncident(e.target.value)}
          autoSize={{
            minRows: 5,
            maxRows: 10,
          }}
          style={{ fontFamily: "Poppins" }}
          placeholder="Report your Issue"
        />
        {incidentError && <p style={{ color: 'red', fontFamily: "Poppims" }}>{incidentError}</p>}
      </Modal>
    </div>
  );
};
export default Navbar;
